import React from "react";
import { Link } from "react-router-dom";
import "./FooterMenu.css";

function FooterMenu() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-header">PRUEBA AZTEQ</h3>
          <Link to="/chat" className="footer-link">Web</Link>
        </div>
        <div className="footer-section">
          <h3 className="footer-header">PRODUCTOS</h3>
          <Link to="/chat" className="footer-link">Chat</Link>
        </div>
        <div className="footer-section">
          <h3 className="footer-header">EMPRESA</h3>
          <Link to="/about" className="footer-link">About</Link>
        </div>
      </div>
    </footer>
  );
}

export default FooterMenu;
